module.exports = __webpack_public_path__ + "img/jdb.105685de.png";